import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import LatestEvents from "../../feature/Common/LatestEvents";
import { injectModels } from "../../redux/injectModels";
import CategorySlider from "../../components/Slider/CategorySlider";
import { handleConsoleError } from "../../utils/common-methods";

function EventsListPage(props) {
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState(null);

  useEffect(() => {
    // Fetch the token from storage then navigate to our appropriate place
    const bootstrapAsync = async () => {
      try {
        props.application.setLoading(true);
        const res = await props.application.getEventCategories();
        if (res?.isSuccess) {
          props.application.setLoading(false);
          if (res?.data?.length > 0) {
            setActiveCategory(res?.data[0]?.id);
            await getEventsByCategoryId(res?.data[0]?.id);
          }
        } else {
          props.application.setLoading(false);
          toast.error(res?.message ||res?.Errors?.[0]?.Message);
          return;
        }
      } catch (e) {
        // Restoring token failed
        const message = handleConsoleError(e);
        props.application.setLoading(false);
        toast.error(e?.message || message);
      }
    };

    bootstrapAsync();
  }, []);

  const getEventsByCategoryId = async (id) => {
    try {
      props.application.setLoading(true);
      const res = await props.application.getEventsByCategoryId(id);
      if (res?.isSuccess) {
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
        //toast.error(res?.message|| res?.Errors?.[0]?.Message || "Something went wrong");
        return;
      }
    } catch (e) {
      // Restoring token failed
     const message= handleConsoleError(e);
      props.application.setLoading(false);
      toast.error(e?.message || message);
    }
  };

  return (
    <React.Fragment>
      <section className="landing-slider">
        <div
          className="carousel"
          role="group"
          aria-label="infinite loop carousel demo"
          aria-roledescription="carousel"
        >
          <div
            className="carousel-slider"
            id="slides"
            aria-atomic="false"
            aria-live="off"
          >
            <div
              className="carousel-slide"
              id="slide1"
              role="group"
              aria-label="1 of 6"
              aria-roledescription="slide"
            >
              <img src="/assets/images/slider-3.png" alt="#" />
            </div>
          </div>
        </div>
      </section>
      <section className="event-tabs">
        <div className="container">
          <h3>
            {location?.state?.type === "upcoming"
              ? "Upcoming"
              : location?.state?.type === "present"
              ? "Present"
              : "Past"}{" "}
            <span> Events</span>
          </h3>
          <div className="event-tabs-img">
            <img src="/assets/images/date-icon.png" alt="" />
          </div>

          <div id="page">
            <div className="row">
              <div className="column small-11 small-centered art1">
                <CategorySlider
                  activeCategory={activeCategory}
                  onCategoryChange={async (category) => {
                    setActiveCategory(category?.id);
                    await getEventsByCategoryId(category?.id);
                  }}
                ></CategorySlider>
              </div>
            </div>
          </div>

          <div className="content">
            <LatestEvents
              statusType={
                location.state?.type === "upcoming"
                  ? "2"
                  : location.state?.type === "present"
                  ? "3"
                  : "4"
              }
              handleAllEvents={() => {}}
              categoryId={activeCategory}
            ></LatestEvents>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default injectModels(["application"])(EventsListPage);
